import parse from 'html-react-parser';

export default function ParseHtml({message}) {
    return parse(message)
}
